Ext.ns('Ext.Alkami');

/*
* Fix issue with combo box not returning the display value but instead of the value
*/
Ext.form.ComboBox.override({
	processValue: function (v) {
		v = Ext.form.ComboBox.superclass.processValue.call(this, v);
		if (this.valueField == 'value') {

			var r = this.findRecord(this.displayField, v);
			var text = v;
			if (r) {
				text = r.data[this.valueField];
			};
			return text;
		};
		return v;
	}
});

Ext.Ajax.on('requestexception', function (conn, res, opts) {
	console.error({ message: "Ext.Ajax request failed", result: res.responseText, options: opts });
});

/**********************
******* TABS **********
**********************/

Ext.Alkami.TabPanel = Ext.extend(Ext.TabPanel, {
	tabMargin: 0,
	tabPosition: 'bottom',
	unstyled: true,
	plain: true,

	initComponent: function () {
		Ext.Alkami.TabPanel.superclass.initComponent.call(this);
	}
});

/****************************
********** DIALOGS **********
*****************************/

Ext.Alkami.Dialog = Ext.extend(Ext.Window, {
	renderTo: Ext.getBody(),
	resizable: false,
	draggable: false,
	unstyled: true,
	modal: true,
	shadow: false,
	width: 475,
	closable: false,
	closeAction: 'hide',
	layout: 'anchor',
	plain: true,
	cls: 'modal dialog',
	autoHeight: true,
	y: 100,
	//buttons: [],
	initHidden: false,

	listeners: {
		'beforerender': function () {
			if (this.initHidden == false && Ext.getBody().hasClass('dialog-is-open')) return false;
		},
		'render': function () {
			if (this.initHidden !== true) Ext.getBody().addClass('dialog-is-open');
		},
		'close': function () {
			Ext.getBody().removeClass('dialog-is-open');
		}
	},

	initComponent: function () {
		this.buttons = this.buttons || [];
		if (!this.buttons.length) {
			this.buttons = [{
			    text: Alkami.Localization.SiteText["Modal.Button.Okay"],
				cls: 'button',
				scale: 'medium',
				scope: this,
				width: 40,
				handler: function() {
					this.close();
				}
			}];
		}

		Ext.Alkami.Dialog.superclass.initComponent.call(this);
	}
});

Ext.Alkami.YesNoDialog = Ext.extend(Ext.Alkami.Dialog, {
	ajaxOptions: null,
	title: Alkami.Localization.SiteText["Modal.Confirm.Title"],
	width: 300,
	cls: 'modal confirm-dialog',

	yesButtonText: Alkami.Localization.SiteText["Modal.Confirm.Button.Yes"],
	noButtonText: Alkami.Localization.SiteText["Modal.Confirm.Button.No"],

    closeOnClick: true,

	initComponent: function () {
		this.buttons = [{
			text: this.noButtonText,
			width: 40,
			cls: 'button secondary',
			scale: 'medium',
			scope: this,
			handler: function () {
				if (this.ajaxOptions['no']) this.ajaxOptions['no'].call();
				this.close();
			}
		}, {
			text: this.yesButtonText,
			width: 40,
			cls: 'button',
			scale: 'medium',
			scope: this,
			handler: function () {
			    if (this.ajaxOptions['yes']) this.ajaxOptions['yes'].call();
			    if (this.closeOnClick) {
			        this.close();
			    }
			}
		}];
		this.buttonAlign = 'right';

		Ext.Alkami.YesNoDialog.superclass.initComponent.call(this);
	}
});

Ext.Alkami.ConfirmDialog = Ext.extend(Ext.Alkami.Dialog, {
	cls: 'modal form-dialog',
	url: null,

	submitBtn: {},
	load: Ext.emptyFn,

	submitHandler: function (form) {
		var self = this,
						$form = $(form),
			formUrl = $form.attr('action');

		//ensure that formUrl has our "magic header" parameter attached
		//need a way to tell the server that we are trying to do a specific request
		//so doing it this way, because of the iframe potential
		//on the server we will sniff all incoming requests that have this parameter, remove the parameter from the dictionary, and keep track of that state for responses to be plain text
		//should most likely be using Ext.String.urlAppend but I'm not entirely sure about that.
		formUrl += (/\?/.test(formUrl) ? "&" : "?") + "ExtFormDialogAJAXRequest=xrequestiframe";

		// disable save button...
		var submitButton = Ext.getCmp('confirm_' + this.id);
		submitButton.addClass('disabled');
		submitButton.setDisabled(true);
		var originalSubmitButtonText = submitButton.getText();
		submitButton.setText('Confirming...');

		Ext.Ajax.request(Ext.apply({
			url: formUrl,
			method: $form.attr('method'),
			form: form,
			isUpload: Ext.get(form.id || form).select('input[type=file]').length > 0,
			scope: this,
			callback: function (options, success, response) {
				submitButton.removeClass('disabled');
				submitButton.setDisabled(false);
				submitButton.setText(originalSubmitButtonText);

				var text = response.responseText,
					res = {},
					multipart = response.hasOwnProperty('status') ? !response.status : false,
					debug = !!window['debugMode'];

				if (multipart) text = $(text).text();

				if ($.isJSON(text))
					res = Ext.decode(text);
				else { // no json means response sent back a non ModalResult (aka error)
					if (this.error) this.error.call(this, text);
					else { // TODO: check response.status to ensure this is an error
						this.close();
						Alkami.FlashBanner.showError("Oops! Something went wrong.");
						if (debug) {
							var d = new Ext.Alkami.Dialog({ width: 800, title: 'Error', html: $(text).html() });
						}
						console.error(text);
					}
					return;
				}

				if (res.upgrade) { // upgrade indicates a ModalResult
					if (res.isValid || res.isFlashMessage)
						Ext.Alkami.handleFormResponse(res, { form: form }, this);
					else {
						res.errors = [''];
						res.error_messages = [res.message];
						res.exception = [''];
						Ext.Alkami.generateFormErrors.call($(form).parent('div'), res);
					}
				}
				else {
					// iframe submit, make sure json text is not wrapped in HTML (use element.innerText)

					if (res.errors) {
						if (this.error) this.error.call(response, res);
						else Ext.Alkami.generateFormErrors.call($(form).parent('div'), res);
					} else {
					    $(form).parent('div').find('div.errors').hide();
					    if (typeof res.error === 'undefined') {
					        Alkami.FlashBanner.showMessage(res.message);
					    } else {
					        Alkami.FlashBanner.showError(res.message);
					    }
					    if (this.success) this.success.call(response, res);
						this.close();
					}
				}
			}
		}, this.ajaxOptions));
	},

	onCancel: Ext.emptyFn,

	initComponent: function () {

		// we do our own buttons.
		var buttons = [{
            text: Alkami.Localization.SiteText["Modal.Confirm.Button.Cancel"],
			cls: 'button secondary',
			scale: 'medium',
			width: 60,
			scope: this,
			id: 'cancel_' + this.id,
			handler: function () {
				if (this.onCancel)
					this.onCancel();

				this.close();
			}
		}, Ext.apply({
			text: Alkami.Localization.SiteText["Modal.Confirm.Button.Confirm"],
			cls: 'button',
			scale: 'medium',
			width: 50,
			scope: this,
			disabled: true,
			id: 'confirm_' + this.id,
			handler: function () {
				if (this.before) this.before.call();
				var form = Ext.getDom(Ext.select('#' + this.id + ' form').elements[0]);
				$(form).validate(); // requires validation to be on all forms, even if it simply returns true.

				if ($(form).valid()) {
					if (this.isAjax === false)
						$(form).submit();
					else
						this.submitHandler.call(this, form);
				}
			}
		}, this.submitBtn)];

		var autoLoad = {
			url: this.url,
			scope: this,
			callback: function () {
				try {
					Ext.getCmp('confirm_' + this.id).enable();
				} catch (error) {
				}
				this.load.call(this);
			},
			scripts: true
		};
		// enable post (and params) for form dialog
		if (this.params)
			autoLoad.params = this.params;

		Ext.apply(this, {
			buttons: (this.buttons && this.buttons.length > 0) ? this.buttons : buttons,
			autoLoad: autoLoad
		});

		Ext.Alkami.ConfirmDialog.superclass.initComponent.call(this);
	}
});

// basic Dialog set up with form buttons (expects probably at least a 'Save'/'Cancel')
// FormDialog expects a RESTful URL to an action that will display a form (i.e. new , edit , etc)
// submission of the form is done via AJAX.
Ext.Alkami.FormDialog = Ext.extend(Ext.Alkami.Dialog, {
	cls: 'modal form-dialog',
	url: null,

	submitBtn: {},
	load: Ext.emptyFn,

	submitHandler: function (form) {
		var self = this,
			$form = $(form),
			formUrl = $form.attr('action');

		//ensure that formUrl has our "magic header" parameter attached
		//need a way to tell the server that we are trying to do a specific request
		//so doing it this way, because of the iframe potential
		//on the server we will sniff all incoming requests that have this parameter, remove the parameter from the dictionary, and keep track of that state for responses to be plain text
		//should most likely be using Ext.String.urlAppend but I'm not entirely sure about that.
		formUrl += (/\?/.test(formUrl) ? "&" : "?") + "ExtFormDialogAJAXRequest=xrequestiframe";

		// disable save button...
		var submitButton = Ext.getCmp('save_' + self.id);
		submitButton.addClass('disabled');
		submitButton.setDisabled(true);
		var originalSubmitButtonText = submitButton.getText();
		submitButton.setText('Saving...');

		var callback = function (options, success, response) {
		    try {
		        submitButton.removeClass('disabled');
		        submitButton.setDisabled(false);
		        submitButton.setText(originalSubmitButtonText);
		    } catch (e) {
		        console.error(e);
		    }

		    var text = response.responseText,
	            res = {},
	            multipart = response.hasOwnProperty('status') ? !response.status : false,
	            debug = !!window['debugMode'];

	        if (multipart) text = $(text).text();

	        if ($.isJSON(text))
	            res = Ext.decode(text);
	        else { // no json means response sent back a non ModalResult (aka error)
	            if (self.error) self.error.call(self, text);
	            else { // TODO: check response.status to ensure this is an error
	                self.close();
	                Alkami.FlashBanner.showError("Oops! Something went wrong.");
	                if (debug) {
	                    var d = new Ext.Alkami.Dialog({ width: 800, title: 'Error', html: $(text).html() });
	                }
	                console.error(text);
	            }
	            return;
	        }

	        if (res.upgrade) { // upgrade indicates a ModalResult
	            Ext.Alkami.handleFormResponse(res, { form: form }, self);
	        } else {
	            // iframe submit, make sure json text is not wrapped in HTML (use element.innerText)

	            if (res.errors) {
	                if (self.error) self.error.call(response, res);
	                else Ext.Alkami.generateFormErrors.call($(form).parent('div'), res);
	            } else {
	                $(form).parent('div').find('div.errors').hide();

	                if (!res.message && response.statusText == "timeout") {
	                    Alkami.FlashBanner.showError("The operation took longer than expected. Please try again.");
	                } else if (res.message && res.info) {
	                    Alkami.FlashBanner.showInfo(res.message);
	                } else if (res.message && !res.isValid) {
	                    Alkami.FlashBanner.showError(res.message);
	                } else if (res.message && res.isValid) {
	                    if (res.showInfo)
	                        Alkami.FlashBanner.showInfo(res.message);
	                    else
	                        Alkami.FlashBanner.showMessage(res.message);
	                }

	                if (self.success) self.success.call(response, res);
	                self.close();
	            }
	        }
	    };

	    var onClose = self.onCancel ? self.onCancel : function() {
	        window.location.href = window.location.href;
	    };

		if ($form.attr('enctype') === 'multipart/form-data') {
			var formData = new FormData($form[0]);
			ajaxSecurePost(formUrl, formData, callback, null, onClose, false, false, $form, false, false);
		} else {
			ajaxSecurePost(formUrl, $form.serialize(), callback, self.error, onClose, false, true, $form);
		}
	},

	onCancel: Ext.emptyFn,

	initComponent: function () {

		// we do our own buttons.
		var buttons = [{
            text: Alkami.Localization.SiteText["Modal.Confirm.Button.Cancel"],
			cls: 'button secondary',
			scale: 'medium',
			width: 60,
			scope: this,
			id: 'cancel_' + this.id,
			handler: function () {
				if (this.onCancel)
					this.onCancel();

				this.close();
			}
		}, Ext.apply({
            text: Alkami.Localization.SiteText["Modal.Confirm.Button.Save"],
			cls: 'button',
			scale: 'medium',
			width: 50,
			scope: this,
			disabled: true,
			id: 'save_' + this.id,
			handler: function () {
				if (this.before) this.before.call();
				var form = Ext.getDom(Ext.select('#' + this.id + ' form').elements[0]);
				$(form).validate(); // requires validation to be on all forms, even if it simply returns true.

				if ($(form).valid()) {
				    if (this.isAjax === false)
				        $(form).submit();
				    else
				        this.submitHandler.call(this, form);
				} else if (this.onValidationError) {
				    this.onValidationError.call();
				}
			}
		}, this.submitBtn)];

		var autoLoad = {
			url: this.url,
			scope: this,
			callback: function (records, operation, success) {
			    if (this.checkOperationOnAutoload === true && operation === false) {
			        var message = "An error occurred.";
                    if (typeof this.autoLoadErrorMessage != "undefined") {
                        message = this.autoLoadErrorMessage;
                    }

                    Alkami.FlashBanner.showError(message);
			        this.close();
			    } else {
			        try {
			            var cmp = Ext.getCmp('save_' + this.id);
			            if (cmp) {
			                cmp.enable();
			            }
			        } catch (error) {
			        }
			        this.load.call(this);
			    }
			},
			scripts: true
		};
		// enable post (and params) for form dialog
		if (this.params)
			autoLoad.params = this.params;

		Ext.apply(this, {
			buttons: (this.buttons && this.buttons.length > 0) ? this.buttons : buttons,
			autoLoad: autoLoad
		});

		Ext.Alkami.FormDialog.superclass.initComponent.call(this);
	}
});

// This FormDialog is not loaded automatically which allows more control over when the ajax call is made
// It also alows you to bypass the default ExtJs loader GIF and use your own style
Ext.Alkami.FormDialogManualLoad = Ext.extend(Ext.Alkami.Dialog, {
    cls: 'modal form-dialog',
    url: null,
    autoLoad: false,
    submitBtn: {},
    load: Ext.emptyFn,

    submitHandler: function (form) {
        var self = this,
						$form = $(form),
			formUrl = $form.attr('action');

        //ensure that formUrl has our "magic header" parameter attached
        //need a way to tell the server that we are trying to do a specific request
        //so doing it this way, because of the iframe potential
        //on the server we will sniff all incoming requests that have this parameter, remove the parameter from the dictionary, and keep track of that state for responses to be plain text
        //should most likely be using Ext.String.urlAppend but I'm not entirely sure about that.
        formUrl += (/\?/.test(formUrl) ? "&" : "?") + "ExtFormDialogAJAXRequest=xrequestiframe";

        // disable save button...
        var submitButton = Ext.getCmp('save_' + this.id);
        submitButton.addClass('disabled');
        submitButton.setDisabled(true);
        var originalSubmitButtonText = submitButton.getText();
        submitButton.setText('Saving...');

        Ext.Ajax.request(Ext.apply({
            url: formUrl,
            method: $form.attr('method'),
            form: form,
            isUpload: Ext.get(form.id || form).select('input[type=file]').length > 0,
            scope: this,
            callback: function (options, success, response) {
                submitButton.removeClass('disabled');
                submitButton.setDisabled(false);
                submitButton.setText(originalSubmitButtonText);

                var text = response.responseText,
					res = {},
					multipart = response.hasOwnProperty('status') ? !response.status : false,
					debug = !!window['debugMode'];

                if (multipart) text = $(text).text();

                if ($.isJSON(text))
                    res = Ext.decode(text);
                else { // no json means response sent back a non ModalResult (aka error)
                    if (this.error) this.error.call(this, text);
                    else { // TODO: check response.status to ensure this is an error
                        this.close();
                        Alkami.FlashBanner.showError("Oops! Something went wrong.");
                        if (debug) {
                            var d = new Ext.Alkami.Dialog({ width: 800, title: 'Error', html: $(text).html() });
                        }
                        console.error(text);
                    }
                    return;
                }

                if (res.upgrade) { // upgrade indicates a ModalResult
                    Ext.Alkami.handleFormResponse(res, { form: form }, this);
                }
                else {
                    // iframe submit, make sure json text is not wrapped in HTML (use element.innerText)

                    if (res.errors || response.statusText == 'timeout') {
                        if(res == '') res = response.statusText;
                        if (this.error) this.error.call(response, res);
                        else Ext.Alkami.generateFormErrors.call($(form).parent('div'), res);
                    } else {
                        $(form).parent('div')
				.find('div.errors').hide();

                        Alkami.FlashBanner.showMessage(res.message);
                        if (this.success) this.success.call(response, res);
                        this.close();
                    }
                }
            }
        }, this.ajaxOptions));
    },

    onCancel: Ext.emptyFn,

    initComponent: function () {

        // we do our own buttons.
        var buttons = [{
            text: Alkami.Localization.SiteText["Modal.Confirm.Button.Cancel"],
            cls: 'button secondary',
            scale: 'medium',
            width: 60,
            scope: this,
            id: 'cancel_' + this.id,
            handler: function () {
                if (this.onCancel)
                    this.onCancel();

                this.close();
            }
        }, Ext.apply({
            text: Alkami.Localization.SiteText["Modal.Confirm.Button.Save"],
            cls: 'button',
            scale: 'medium',
            width: 50,
            scope: this,
            disabled: true,
            id: 'save_' + this.id,
            handler: function () {
                if (this.before) this.before.call();
                var form = Ext.getDom(Ext.select('#' + this.id + ' form').elements[0]);
                $(form).validate(); // requires validation to be on all forms, even if it simply returns true.

                if ($(form).valid()) {
                    if (this.isAjax === false)
                        $(form).submit();
                    else
                        this.submitHandler.call(this, form);
                }
            }
        }, this.submitBtn)];

        Ext.apply(this, {
            buttons: (this.buttons && this.buttons.length > 0) ? this.buttons : buttons,
        });

        Ext.Alkami.FormDialog.superclass.initComponent.call(this);
    }
});

// hybrid between Dialog and TabPanel (well, not TabPanel yet because tabs don't work in forms in ExtJS 3)
Ext.Alkami.WizardDialog = Ext.extend(Ext.Alkami.Dialog, {
	id: 'modal_form',
	cls: 'modal wizard-dialog',
	url: null,

	load: Ext.emptyFn,
	initHidden: false,

	layout: 'fit',

	/*** can't get tabs navigation working until we get ExtJS TabPanel working with forms which will probably not be until v4 ***/
	navigateForward: function () {
		// hide current button, show next tab in list, show next button in list, show back button
	},
	navigateBackward: function () {
		// hide current button, show previous button in list, show previous tab in list
		// IF active tab == 0, hide back button
	},

	initComponent: function () {
		var dialog = this;

		var buttonDefaults = {
			// handler: dialog.navigateForward,
			width: 50,
			cls: 'button',
			scope: dialog,
			scale: 'medium'
		};

		$.each(this.buttons, function (i, button) {
			if (button.save) {
				// add ajax handler...

				button.handler = function () {
					if (button.before) button.before.call();
					var form = Ext.getDom(Ext.select('#' + dialog.id + ' form').elements[0]);

					var ajaxDefaults = Ext.apply({
						url: form.action,
						method: form.method,
						form: form,
						callback: function (options, success, response) {
							var text = response.responseText,
								data = {},
								multipart = !response.status;

							// iframe submit, make sure json text is not wrapped in HTML (use element.innerText)
							if (multipart) text = $(text).text();

							if ($.isJSON(text)) data = Ext.decode(text);

							if (data.errors) {
								if (button.error) button.error.call(response, data);
								else Ext.Alkami.generateFormErrors.call($(form).parent('div'), data);
							} else {
								$(form).parent('div')
									.find('div.errors').hide();

								Alkami.FlashBanner.showMessage(data.message);
								if (button.success) button.success.call(response, data);
								dialog.close();
							}
						}
					}, button.ajaxOptions);

					Ext.Ajax.request(ajaxDefaults);
				};
			}
			Ext.applyIf(button, buttonDefaults);
		});

		if (this.url) {
			this.autoLoad = {
				url: this.url,
				callback: function() {
					dialog.load.call(dialog);
				},
				scripts: true
			};
		}

		Ext.Alkami.WizardDialog.superclass.initComponent.call(this);
	}
});

Ext.Alkami.handleFormResponse = function (res, config, thisp) {
	var flashed = false;
	if ('string' === typeof (res)) {
		if (thisp && thisp.exception) thisp.exception.call(thisp, res);
		return;
	}

	if ('errors' in res || 'exception' in res || !res.isValid) {
		var proceed = undefined;
		if (thisp && thisp.error && !config.omitErrorFn)
			proceed = thisp.error.call(thisp, res);
		// else Ext.Alkami.generateFormErrors.call($(config.form).parent('div'), res); // JR 4.4.12, why pass parent div?
		if ((proceed === true || proceed === undefined) || config.forceErrors)
			Ext.Alkami.generateFormErrors.call(config.form, res);

		// will show flashError
		if (flashed = ('flash' in res)) {
			Alkami.FlashBanner.showError(res.flash);
		}
	}

	if ('result' in res) {
		$(config.form).parent('div')
			.find('div.errors').hide();

		if (thisp && thisp.success) thisp.success.call(thisp, res.result);
		if (thisp && thisp.ajaxOptions && thisp.ajaxOptions.success) thisp.ajaxOptions.success.call(thisp, res.result);

		// will show flashSuccess
		if (flashed = ('flash' in res)) {
			Alkami.FlashBanner.showMessage(res.flash);
		}

		if (thisp && thisp.close) {
			thisp.close();
		}
	}

	if (!flashed && ('flash' in res)) {
		if (res.isValid) {
			Alkami.FlashBanner.showMessage(res.flash);
		} else {
			Alkami.FlashBanner.showError(res.flash);
		}
	}
	if (('disableForm' in res) && res.disableForm) {
	    $('input').prop('disabled', true);
	    var not = $(config.form).children().not('div.errors');
	    not.prop('disabled', true).addClass('disabled');
	    $('#save_modal_form button').addClass('disabled').prop('disabled', true); //for now disables save button in modals for DEV-300
	}
};

Ext.Alkami.generateFormErrors = function (res) {
	var debug = !!window['debugMode'];

	if (!(res.exception || res.errors) || res.isValid) {
		$(this).find('div.errors').hide();
		return;
	}
	var dialog = $(this),
		errors = dialog.find('div.errors').show(),
		err = res.errors,
		msg = res.error_messages,
		ex = res.exception;

	// create error container if one does not exist
	errors = displayErrorContainerForForm(dialog);
	errors.removeClass('one');
	// Model State errors
	var list = errors.find('ul').empty();
	if (err && msg) {
		// single message error
		// e.g. ModelState.AddModelError(string.Empty, "Some message")
		if (err.length === 1 && err[0] === '') {
			errors.find('.error-title').html(msg[0]);
			errors.addClass('one');
		}
		else {
			for (var i = 0; i < err.length; i++) {
				// add validator err[i] message by field name
				list.append('<li>' + msg[i] + '</li>');
				var input = $('input[name="' + err[i] + '"]').filter(':not(:disabled)');
				if (input.length)
					input.closest('.field').addErrors();
			}
			errors.removeClass('one');
		}
	} else if (res.message) {
	    errors.find('.error-title').html(res.message);
	}
	var exception = errors.find('div.exception').empty();
	if (debug) {
		if (ex) {
			exception.append('<h3>Exception</h3>');
			exception.append('<div class="exception_message">' + ex.message + '</div>');
			exception.append('<div class="exception_inner_message">' + ex.innerMessage + '</div>');
			exception.append('<div class="exception_stack_trace">' + ex.stackTrace + '</div>');
		}
	}

	if (ex) console.error(ex.message, ex.innerMessage, ex.stackTrace, ex);
};
/***********************
******* STORE **********
***********************/

Ext.Alkami.ExpansionStore = Ext.extend(Ext.data.JsonStore, {
	constructor: function (config) {
		if (typeof config.url != 'undefined') {
			Ext.applyIf(config, {
				idProperty: 'id',
				autoLoad: true,
				totalProperty: 'results',
				restful: true
			});
		} else if (typeof config.proxy != 'undefined') {
			Ext.applyIf(config, {
				idProperty: 'id',
				autoLoad: true,
				totalProperty: 'results'
			});
		} else {
			// we don't need root (in fact it causes problems) if there is no URL supplied..
			delete config['root'];
		}

		Ext.Alkami.ExpansionStore.superclass.constructor.call(this, config);
	}
});

/***********************
******* COMBO **********
***********************/
var usStates = [
	{ name: 'Alabama', value: 'AL'},
	{ name: 'Alaska', value: 'AK'},
	{ name: 'Arizona', value: 'AZ'},
	{ name: 'Arkansas', value: 'AR'},
	{ name: 'California', value: 'CA'},
	{ name: 'Colorado', value: 'CO'},
	{ name: 'Connecticut', value: 'CT'},
	{ name: 'Delaware', value: 'DE'},
    { name: 'District of Columbia', value: 'DC' },
	{ name: 'Florida', value: 'FL' },
	{ name: 'Georgia', value: 'GA'},
	{ name: 'Hawaii', value: 'HI'},
	{ name: 'Idaho', value: 'ID'},
	{ name: 'Illinois', value: 'IL'},
	{ name: 'Indiana', value: 'IN'},
	{ name: 'Iowa', value: 'IA'},
	{ name: 'Kansas', value: 'KS'},
	{ name: 'Kentucky', value: 'KY'},
	{ name: 'Louisiana', value: 'LA'},
	{ name: 'Maine', value: 'ME'},
	{ name: 'Maryland', value: 'MD'},
	{ name: 'Massachussetts', value: 'MA'},
	{ name: 'Michigan', value: 'MI'},
	{ name: 'Minnesota', value: 'MN'},
	{ name: 'Mississippi', value: 'MS'},
	{ name: 'Missouri', value: 'MO'},
	{ name: 'Montana', value: 'MT'},
	{ name: 'Nebraska', value: 'NE'},
	{ name: 'Nevada', value: 'NV'},
	{ name: 'New Hampshire', value: 'NH'},
	{ name: 'New Jersey', value: 'NJ'},
	{ name: 'New Mexico', value: 'NM'},
	{ name: 'New York', value: 'NY'},
	{ name: 'North Carolina', value: 'NC'},
	{ name: 'North Dakota', value: 'ND'},
	{ name: 'Ohio', value: 'OH'},
	{ name: 'Oklahoma', value: 'OK'},
	{ name: 'Oregon', value: 'OR'},
	{ name: 'Pennsylvania', value: 'PA'},
	{ name: 'Rhode Island', value: 'RI'},
	{ name: 'South Carolina', value: 'SC'},
	{ name: 'South Dakota', value: 'SD'},
	{ name: 'Tennessee', value: 'TN'},
	{ name: 'Texas', value: 'TX'},
	{ name: 'Utah', value: 'UT'},
	{ name: 'Vermont', value: 'VT'},
	{ name: 'Virginia', value: 'VA'},
	{ name: 'Washington', value: 'WA'},
	{ name: 'West Virginia', value: 'WV'},
	{ name: 'Wisconsin', value: 'WI'},
	{ name: 'Wyoming', value: 'WY' },
    { name: 'American Samoa', value: 'AS' },
    { name: 'Federated States of Micronesia', value: 'FM' },
    { name: 'Guam', value: 'GU' },
    { name: 'Marshall Islands', value: 'MH' },
    { name: 'Northern Mariana Islands', value: 'MP' },
    { name: 'Palau', value: 'PW' },
    { name: 'Puerto Rico', value: 'PR' },
    { name: 'Virgin Islands', value: 'VI' }
];
Ext.Alkami.StateComboBox = Ext.extend(Ext.form.ComboBox, {
	selectOnFocus: true,
	mode: 'local',
	triggerAction: 'all',
	editable: false,
	shadow: false,
	width: 200,
	store: new Ext.data.JsonStore({
		fields: ['name', 'value'],
		data: usStates
	}),
	displayField: 'name',
	valueField: 'value'
});

Ext.Alkami.ManagedPayeesComboBox = Ext.extend(Ext.form.ComboBox, {
    mode: 'remote',
    hideTrigger: 'true',
    minChars: 3,
    displayField: 'name',
    valueField: 'name'
});

Ext.Alkami.ResourceComboBox = Ext.extend(Ext.form.ComboBox, {
	selectOnFocus: true,
	mode: 'local',
	triggerAction: 'all',
	shadow: false,
	width: 250,
	valueField: 'id',
	forceSelection: true,

	initComponent: function () {

		if (this.transform && !document.getElementById(this.transform)) {
			return;
		}

		if (this.resource) {
			var res = this.resource;

			if (!this.itemSelector) this.itemSelector = 'div.' + res;
			if (!this.ctCls) this.ctCls = res + '-list';
			if (!this.tpl) this.tpl = new Ext.XTemplate('<tpl for="."><div class="' + res + ' list-item">' + this.innerTpl + '</div></tpl>');
			if (!this.emptyText) this.emptyText = 'Select ' + Alkami.Utils.StringHelper.titleize(res);
		}

		Ext.Alkami.ResourceComboBox.superclass.initComponent.call(this);
	}
});

/*************************
******* TXN GRID *********
*************************/

Ext.Alkami.TransactionGrid = Ext.extend(Ext.grid.EditorGridPanel, {
	renderTo: 'transactions',
	stripeRows: true,
	clicksToEdit: 1,
	autoHeight: true,
	checkboxSelection: false,
	categoryCombo: null,
	paging: true,
	loadMask: true,
	enableColumnMove: false,
	listeners: {
		beforeedit: function (evt) {
			if (!evt.record.data.amount)
				return false;
		}
	},
	comboRenderer: function (grid) {
		return function (value, cellInfo, record, rowIndex, colIndex, store) {
			if (record.data.amount !== "") {
				var tc = record.get('transaction_categories');
				if (tc instanceof Array) {
					if (tc.length > 1) {// split
						return '<span class="split">Split</span>';
					} else if (!tc.length) {
						return '<em>Uncategorized</em>';
					}
					var categoryRec = (grid.catStore.getById(tc[0]) || grid.catStore.getById(tc[0] && tc[0].id));

					return categoryRec ? categoryRec.get('name') : tc[0].name;
				} else {
                    // get parent records by id
				    var res = grid.catStore.getById(value);
				    // if parent record not found, search any sub-categories and set value if found
				    if (!res) {
				        var done = false;
				        for (var i in grid.catStore.data.items) {
				            var data = grid.catStore.data.items[i].data;
				            if (data && data.hasOwnProperty('children')) {
				                for (var j in data.children) {
				                    var subitem = data.children[j];
				                    if (subitem.id == value) {
				                        res = subitem.name;
				                        done = true;
				                        break;
				                    }
				                }
				            }
				            if (done) break;
				        }
				    }
				    else
				        res = res.get('name');
				    return res ? res : value[0].name;
				}
			}
		}
	},

	accountColorRenderer: function (v, p, record) {
		return '<div style="font-size: 12px;"><span class="bar account-color-' + record.data.custody_color + '-bg"></span></div>';
	},

	setupColumnModel: function () {
		var checkboxes = new Ext.grid.CheckboxSelectionModel({ checkOnly: true, moveEditorOnEnter: false });
		if (this.checkboxSelection) {
			this.sm = checkboxes;
		}

		this.cm = new Ext.grid.ColumnModel({
			defaults: {
				sortable: true,
				resizable: false,
				menuDisabled: true
			},
			columns: [
				checkboxes,
				{ header: '', width: 20, renderer: this.accountColorRenderer },
				{ header: 'Date', width: 60, dataIndex: 'date', id: 'date' },
				{ header: 'Type', width: 90, dataIndex: 'transaction_type', id: 'transaction_type' },
				{ header: 'Description', width: 250, dataIndex: 'description', id: 'description' },
				{ header: 'Category', width: 120, dataIndex: 'transaction_categories', renderer: this.comboRenderer(this), id: 'category' },
				{ header: 'Principal', width: 100, dataIndex: 'principal_amount', renderer: moneyRenderer, align: 'right', id: 'principal', hidden: true, sortable: false },
				{ header: 'Interest', width: 100, dataIndex: 'interest_amount', renderer: moneyRenderer, align: 'right', id: 'interest', hidden: true, sortable: false },
				{ header: 'Amount', width: 100, dataIndex: 'amount', renderer: moneyRenderer, align: 'right', id: 'amount', hidden: true, sortable: false },
				{ header: 'Credits', width: 90, renderer: moneyRenderer, align: 'right', dataIndex: 'credits', id: 'credits' },
				{ header: 'Debits', width: 90, renderer: moneyRenderer, align: 'right', dataIndex: 'debits', id: 'debits' },
				{ header: 'Balance', width: 100, renderer: moneyRenderer, align: 'right', dataIndex: 'balance', id: 'balance', sortable: false },
				{ header: '', width: 42, dataIndex: 'alert', renderer: function () { return '&nbsp;'; }, id: 'alert' }
			]
		});

		if (!this.checkboxSelection) {
			this.cm.setHidden(0, true);
		}
	},

	setupPaging: function () {
		if (!this.paging) return;

		var pageResizer = new Ext.ux.plugins.PageCycleResizer({
			pageSizes: [25, 50, 100],
			prependText: '',
			appendText: ' per page',
			iconCls: 'arrow-down'
		});

		var pagingToolbar = new Ext.PagingToolbar({
			pageSize: this.txnPerPage,
			store: this.store,
			displayInfo: true,
			displayMsg: '',
			buttonAlign: 'left',
			emptyMsg: "Nothing to display",
			beforePageText: '',
			plugins: [pageResizer]
		});
		this.bbar = pagingToolbar;
	},

	initComponent: function () {
		this.setupPaging();

		if (!this.cm && !this.columns) {
			this.setupColumnModel();
		}

		if (this.detailsOnClick) {
			if (this.detailsOnClick === true) {
				this.on("rowclick", this.showTxnDetails);
			} else {
				this.on("cellclick", this.showTxnDetails);
			}
		}

		if (this.catStore) {
			var categoryColumnIndex = this.cm.findColumnIndex('transaction_categories');
			var editor = new Ext.Alkami.CategoryCombo({
				showSplitOption: true,
				showUncategorizedOption: true,
				store: this.catStore,
				listeners: {
					beforeshow: function (el) {
						if (this.gridEditor.record && this.gridEditor.record.data.transaction_categories.length) {
							this.setRawValue(this.gridEditor.record.data.transaction_categories[0].name);
						}
					}
				}
			});
			this.categoryCombo = editor;
			this.cm.setEditor(categoryColumnIndex, editor);
			var col = this.cm.getColumnAt(categoryColumnIndex);
			//col.editor.addListener('beforeshow', , col.editor);

		}

		Ext.Alkami.TransactionGrid.superclass.initComponent.call(this);

		if (this.detailsOnClick) {
			this.addEvents('detailshow');
		}
	},

	showTxnDetails: function (grid, rowIndex, columnIndex, e) {
		// if a column dataIndex was passed to detailsOnClick, then on cell click should only show if clicked cell matches dataIndex.

		var activeTxnRecord = grid.getStore().getAt(rowIndex);
		var clickedDetailColumn = (grid.detailsOnClick !== true && grid.getColumnModel().getDataIndex(columnIndex) == grid.detailsOnClick);
		var categoryColumnIndex = grid.getColumnModel().findColumnIndex('transaction_categories');
		var clickedCategoryColumn = (columnIndex == categoryColumnIndex);

		var txnIsSplit = (activeTxnRecord.get('transaction_categories') instanceof Array) && activeTxnRecord.get('transaction_categories').length > 1;

		grid.getColumnModel().setEditable(categoryColumnIndex, !txnIsSplit);

		if (!(clickedDetailColumn || (clickedCategoryColumn && txnIsSplit))) {
		    var editor = {};
		    if (grid.getColumnModel().config[columnIndex].checkOnly) {
		        columnIndex += 1;
		    }
		    editor = grid.getColumnModel().getCellEditor(columnIndex, rowIndex);
		    var categories = activeTxnRecord.get('transaction_categories');
		    if ((categories instanceof Array) && (categories.length == 0)) {
		        categories = "0";
		    }
		    if (editor && editor.setValue) {
		        editor.setValue(categories);
		    }
		    return;
		}

        // Transaction details modal.
		var url = '/API/Transactions/TransactionDetails';
		var loadingHtml = '<div class="modal-header"><h1>Transaction Details</h1><a href="#" class="icon-close" title="Close">Close</a></div><div class="loading"><p>Loading transaction details...</p></div>';

		window.detailWindow = new Ext.Alkami.FormDialogManualLoad({
			id: 'txn_details',
			title: '',
            html: loadingHtml,
            url: url,
            loadMask: false,
			params: {
				accountIdentifier: activeTxnRecord.get('account_id'),
				transactionId: activeTxnRecord.get('id'),
				isMobile: false
			},
			listeners: {
			    'render': function () {
			        Ext.getCmp('save_txn_details').hide();
			        Ext.getCmp('cancel_txn_details').hide();
			        $.ajax({
			            type: "GET",
			            url: url,
			            data: {
			                accountIdentifier: activeTxnRecord.get('account_id'),
			                transactionId: activeTxnRecord.get('id'),
			                isMobile: false
			            },
			            success: function (data) {
			                if (!Ext.getCmp('txn_details'))
			                    return;

			                Ext.getCmp('txn_details').update(data);
			                try {
			                    Ext.getCmp('save_txn_details').show();
			                    Ext.getCmp('save_txn_details').enable();
			                    Ext.getCmp('cancel_txn_details').show();
			                } catch (error) {
			                }
			                Ext.getCmp('txn_details').load.call(Ext.getCmp('txn_details'));
			                transactionDetailsScriptLoaded();
			            },
			            error: function (request, status, error) {
			                $('#txn_details div.loading').html('<div class="empty"><p>There was an error loading your transaction details.</p></div>');
			                $('#txn_details div.loading').removeClass('loading');
			                try {
			                    Ext.getCmp('cancel_txn_details').setText('Ok');
			                    Ext.getCmp('cancel_txn_details').show();
			                    Ext.getCmp('cancel_txn_details').enable();
			                } catch (e) {
			                }
			            }
			        });
			    }
			},
			success: function () {
				grid.getStore().reload();
			}
		});

		var gridRow = grid.getView().getRow(rowIndex);
		detailWindow.show();

		if (this.detailsOnClick) this.fireEvent('detailshow', this, detailWindow, activeTxnRecord);

	}

});

Ext.Alkami.CategoryCombo = Ext.extend(Ext.form.ComboBox, {
	mode: 'local',
	triggerAction: 'all',
	typeAhead: true,
	forceSelection: true,
	valueField: 'id',
	displayField: 'name',
	editable: false,
	lazyRender: true,
	listClass: 'category-list',
	shadow: false,
	emptyText: 'Select Category',
	showSplitOption: false,
	showUncategorizedOption: false,
	showAllCategoriesOption: false,
	listAlign:'tl-bl',

	onViewClick: function (doFocus) {
		var selectedNode = this.view.getSelectedNodes()[0];
		var index = this.view.getSelectedIndexes()[0];
		var selectedValue = $(selectedNode).attr('data-value');

		if (selectedValue == 'manage') {
			this.collapse();
			if (this.gridEditor) this.gridEditor.cancelEdit();
			var t = this;
			Ext.getBody().removeClass('dialog-is-open');
			var d = new Ext.Alkami.FormDialog({
				id: 'manage_cats',
				title: 'Manage Categories',
				width: 705,
				url: '/API/TransactionCategories/ManageCategories',
				y: 50,
				buttons: [{
                    text: Alkami.Localization.SiteText["Modal.Button.Okay"],
					cls: 'button',
					scale: 'medium',
					width: 60,
					id: 'close_manage_categories',
					handler: function () {
					    if (t.store.url)    //need a URL.  If we don't have one, look for the category store and refresh it.
					        t.store.reload();
					    else {
					        var s = Ext.StoreMgr.get('categoryStore');
					        if (s)
					            s.reload();
					    }
					    d.close();
					}
				}]
			});
		} else if (selectedValue == 'split') {
			this.collapse();
			var gridEditor = this.gridEditor;
			if (gridEditor) gridEditor.cancelEdit();

		    // Transaction details modal.
			var url = '/API/Transactions/TransactionDetails';
			var loadingHtml = '<div class="modal-header"><h1>Transaction Details</h1><a href="#" class="icon-close" title="Close">Close</a></div><div class="loading"><p>Loading transaction details...</p></div>';

			window.detailWindow = new Ext.Alkami.FormDialogManualLoad({
			    id: 'txn_details',
			    title: '',
			    html: loadingHtml,
			    url: url,
			    loadMask: false,
			    params: {
			        accountIdentifier: gridEditor.record.get('account_id'),
			        transactionId: gridEditor.record.get('id'),
			        isMobile: false
			    },
			    listeners: {
			        'render': function () {
			            Ext.getCmp('save_txn_details').hide();
			            Ext.getCmp('cancel_txn_details').hide();
			            $.ajax({
			                type: "GET",
			                url: url,
			                data: {
			                    accountIdentifier: gridEditor.record.get('account_id'),
			                    transactionId: gridEditor.record.get('id'),
			                    isMobile: false
			                },
			                success: function (data) {
			                    if (!Ext.getCmp('txn_details'))
			                        return;

			                    Ext.getCmp('txn_details').update(data);
			                    try {
			                        Ext.getCmp('save_txn_details').show();
			                        Ext.getCmp('save_txn_details').enable();
			                        Ext.getCmp('cancel_txn_details').show();
			                    } catch (error) {
			                    }
			                    Ext.getCmp('txn_details').load.call(Ext.getCmp('txn_details'));
			                    transactionDetailsScriptLoaded();
			                },
			                error: function (request, status, error) {
			                    $('#txn_details div.loading').html('<div class="empty"><p>There was an error loading your transaction details.</p></div>');
			                    $('#txn_details div.loading').removeClass('loading');
			                    try {
			                        Ext.getCmp('cancel_txn_details').setText('Ok');
			                        Ext.getCmp('cancel_txn_details').show();
			                        Ext.getCmp('cancel_txn_details').enable();
			                    } catch (e) {
			                    }
			                }
			            });
			        }
			    },
			    success: function () {
					if (gridEditor) gridEditor.record.store.reload();
				}
			});
			detailWindow.show();
		} else {
			var catId = parseInt(selectedValue),
				rec;

			if (isNaN(catId)) {
				rec = this.store.getAt(this.store.findExact('name', 'All Categories'));
			} else if (catId >= 0) {
			    // getById only returns "top-level" categories
				rec = this.store.getById(catId);
			    // if not found, search sub-categories and set value if found
			    if (!rec) {
			        this.setValue(catId);
			    }
			} else {
				// clicked Uncategorized - I know, hacky :(
				rec = this.store.getAt(this.store.findExact('name', 'Uncategorized'));
			}

			if (rec) {
				this.onSelect(rec, index);
			} else {
				this.collapse();
			}
		}

		if (doFocus !== false) {
			this.el.focus();
		}
	},

    setValue: function(value) {
        if (value != '') {
            var rec = (value == '') ? null : this.store.getById(value);
            var text = this.valueNotFoundText;
            if (!rec) {
                for (var i in this.store.data.items) {
                    var data = this.store.data.items[i].data;
                    if (data && data.hasOwnProperty('children')) {
                        for (var j in data.children) {
                            var subitem = data.children[j];
                            if (subitem.id == value) {
                                text = subitem.name;
                            }
                        }
                    }
                }
            } else {
                text = rec.data[this.displayField];
            }
            this.lastSelectionText = text;
            if (this.hiddenField) {
                this.hiddenField.value = Ext.value(value, '');
            }
            Ext.form.ComboBox.superclass.setValue.call(this, text);
        }

        this.value = value;

        return this;
    },

	addUncategorizedOption: function () {
		if (this.store.findExact('name', 'Uncategorized') > -1) return;

		var store = this.store;
		var rec = new store.recordType({
			name: 'Uncategorized', is_child: false, children: [], id: "0"
		}, 0);
		store.insert(store.data.items.length, rec);
		this.bindStore(store);
	},

	addAllCategoriesOption: function () {
		if (this.store.findExact('name', 'All Categories') > -1) return;

		var store = this.store;
		var rec = new store.recordType({
			name: 'All Categories', is_child: false, children: [], id: "&nbsp;"
		}, 99999999999); // hopefully that's a unique enough ID :)
		store.insert(0, rec);
		this.bindStore(store);
	},

	initComponent: function () {
		var config = this;
		config._splitRendered = false;
		config._mcRendered = false;

		/** NOTE: this is ghetto... thanks ExtJS for your incredible event handling... **/
		if (config.showAllCategoriesOption) {
			if (config.store.data.length) {
				config.addAllCategoriesOption();
			} else {
				config.store.on('load', function () {
					config.addAllCategoriesOption();
				});
			}
		}
		if (config.showUncategorizedOption) {
			if (config.store.data.length) {
				config.addUncategorizedOption();
			} else {
				config.store.on('load', function () {
					config.addUncategorizedOption();
				});
			}
		}

		config.tpl = new Ext.XTemplate(
			'<ul class="category-list">',
			'<tpl for=".">',
				'<tpl if="is_child==false"><li data-value="{id}" class="x-combo-list-item">{name}',
				'<tpl if="this.hasChildren(children)">',
					'<ul><tpl for="children">',
					'<li data-value="{id}" class="x-combo-list-item">{name}</li>',
					'</tpl></ul>',
				'</tpl>',
				'</li></tpl>',
			'</tpl>',
			'<tpl if="this.showSplitOption()"><li class="x-combo-list-item split" id="split_' + config.id + '" data-value="split">Split...</li></tpl>',
			'<li class="x-combo-list-item manage" id="manage_' + config.id + '" data-value="manage">Manage Categories...</li>',
			'</ul>',
			{
				compiled: true,
				hasChildren: function (children) {
					if (children.length) return true;
					return false;
				},
				showSplitOption: function () {
					return config.showSplitOption && !$('#split_' + config.id).length;
				}
			}
		),
		Ext.Alkami.CategoryCombo.superclass.initComponent(config);
	}
});

Ext.reg('Alkami.CategoryCombo', Ext.Alkami.CategoryCombo);
